const states = [
    {
        id: 1,
        label: 'Active',
        color1: 'color-3',
        color2: 'lightest',
    },
    {
        id: 0,
        label: 'Draft',
        color1: 'medium',
        color2: 'lightest',
    },
    {
        id: 2,
        label: 'Inactive',
        color1: 'color-6',
        color2: 'lightest',
    },
    {
        id: 3,
        label: 'Closed',
        color1: 'color-6',
        color2: 'lightest',
    },
]

const audience = [
    {
        id: 0,
        label: 'Tourist'
    },
    {
        id: 1,
        label: 'Agent'
    },
]

const daysInAdvance = [
    {
        id: 0,
        label: 'Anytime'
    },
    {
        id: 1,
        label: '24 Hours'
    },
    {
        id: 2,
        label: '48 Hours'
    },
    {
        id: 5,
        label: '5 Days'
    },
    {
        id: 7,
        label: '7 Days'
    },
    {
        id: 10,
        label: '10 Days'
    },
    {
        id: 15,
        label: '15 Days'
    },
    {
        id: 20,
        label: '20 Days'
    },
    {
        id: 25,
        label: '25 Days'
    },
    {
        id: 500,
        label: '1 Month'
    },
]

const samplePromocodes = [
    {
        id: 123,
        code: 'DUMMY-ABCD123XYZ',
        promocodeType: 0, // 0 - Tourist
        value: 25,
        amountType: 1, // 0 cash, 1 percentage
        maxQuantity: null,
        numberOfUses: 12,
        applyToExtras: false,
        applyToPickups: false,
        bookingPeriodStart: '2019-01-01',
        bookingPeriodFinish: '2019-06-01',
        bookingDaysInAdvance: 0, // any time
        validPeriodStart: '2019-01-01',
        validPeriodFinish: '2019-01-01',
        validDaysOfWeek: [1, 2, 3, 4, 5, 6, 0], // all days of the week
        validPeriodStartTime: '00:00:00',
        validPeriodFinishTime: '23:59:59',
        isForAllProducts: true,
        isForAllAgents: true,
        status: 1, // 1 - Active
        products: [],
        agents: [],
    }
]

const virginPromocode = {
    // id: null,
    code: null,
    promocodeType: 0, // 0 - Tourist
    value: null,
    amountType: 1, // 0 cash, 1 percentage
    maxQuantity: null,
    isMaxQuantityPerPerson: false,
    numberOfUses: 0,
    applyToExtras: false,
    applyToPickups: false,
    bookingPeriodStart: null,
    bookingPeriodFinish: null,
    bookingDaysInAdvance: 0, // any time
    validPeriodStart: null,
    validPeriodFinish: null,
    validDaysOfWeek: [], // no days of the week selected
    validPeriodStartTime: '00:00:00',
    validPeriodFinishTime: '23:59:59',
    isForAllProducts: true,
    isForAllAgents: true,
    status: 0, // 0 - Draft
    products: [],
    agents: [],
}

export default {
    states,
    audience,
    daysInAdvance,
    samplePromocodes,
    virginPromocode,
}



// WEBPACK FOOTER //
// ./src/store/modules/promocodes/promocodesStatic.js